import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "1357c637-cae8-4936-b678-86f7d8fa51f5",
    content: "The sound transmission is highly depending on the sound source.",
    options: {},
  },
  {
    id: "b909a206-d826-457c-91ef-6df01575a447",
    content: "The final impulse response depends on the properties of the receiver room.",
    options: {},
  },
  {
    id: "4381f1bc-2cf4-4693-a755-1e006c430a60",
    content: "The final impulse response depends on the properties of the source room. ",
    options: {},
  },
  {
    id: "f8a2e5a7-a244-46be-9d80-415316715a8a",
    content:
      "The audible sound in the receiver room depends on the properties of the sound source and the impact force onto the wall or floor element.",
    options: {},
  },
];

export const task: Task = {
  id: "57b54570-e91e-4c60-8158-01871769c390",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "1357c637-cae8-4936-b678-86f7d8fa51f5",
    "b909a206-d826-457c-91ef-6df01575a447",
    "4381f1bc-2cf4-4693-a755-1e006c430a60",
    "f8a2e5a7-a244-46be-9d80-415316715a8a",
  ],
};
